// extracted by mini-css-extract-plugin
export default {"post-preview-header":"PostPreviewHeader_post-preview-header__2qDw9","post-preview-header--near":"PostPreviewHeader_post-preview-header--near__C+68D"};